var React = require('react');

function Parking (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M452 0H60C26.916 0 0 26.916 0 60v392c0 33.084 26.916 60 60 60h392c33.084 0 60-26.916 60-60V60c0-33.084-26.916-60-60-60zm20 452c0 11.028-8.972 20-20 20H60c-11.028 0-20-8.972-20-20V60c0-11.028 8.972-20 20-20h392c11.028 0 20 8.972 20 20v392z","key":0}),React.createElement("path",{"d":"M286 100H146v312h40V300h100c55.14 0 100-44.86 100-100s-44.86-100-100-100zm0 160H186V140h100c33.084 0 60 26.916 60 60s-26.916 60-60 60z","key":1})]);
}

Parking.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Parking;

Parking.default = Parking;
